import React from 'react';

const ELDCamera = ({ operations }) => {
  return (
    <div className="max-w-6xl mx-auto p-6 bg-white">
      <h2 className="text-2xl font-bold text-red-500 text-center mb-2">
        ELD/CAMERA
      </h2>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-[#666666] text-white font-bold">
              <th className="px-4 py-2 text-center">
                Telematics Type
              </th>
              <th className="px-4 py-2 text-center">
                Connection Method
              </th>
              <th className="px-4 py-2 text-center">
                Time Alotted to connect device(s)
              </th>
              <th className="px-4 py-2 text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-white text-sm">
              <td className="px-4 py-2 text-center font-bold">
                <strong>ELD</strong>
              </td>
              <td className="px-4 py-2 text-center">
                Connect Current ELD device(s) to Cover Whale using the
                link emailed to you at binding
              </td>
              <td className="px-4 py-2 text-center">
                10 Days from the bind date
              </td>
              {operations?.dataSharingOption === 'eld_only' ? (
                <td className="px-4 py-2 text-center">Included</td>
              ) : (
                <td className="px-4 py-2 text-center text-red-500">
                  Excluded
                </td>
              )}
            </tr>
            <tr className="bg-gray-50 text-sm">
              <td className="px-4 py-2 text-center font-bold">
                <strong>DASH CAMERA</strong>
              </td>
              <td className="px-4 py-2 text-center">
                Install and turn on the camera(s) that will be shipped
                to you post-binding
              </td>
              <td className="px-4 py-2 text-center">
                10 Days from when the shipment is delivered to the
                insured
              </td>
              {operations?.dataSharingOption ===
              'dash_cam_dual_ai_connected' ? (
                <td className="px-4 py-2 text-center">Included</td>
              ) : (
                <td className="px-4 py-2 text-center text-red-500">
                  Excluded
                </td>
              )}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ELDCamera;
